// **React Imports
import { memo, useContext, useMemo } from 'react'

// **MUI Imports
import { Box, Typography } from '@mui/material'

// **Hooks Imports
import useDemoUser from '../../hooks/useDemoUser'

// **Style Imports
import { SettingsContext } from '../../context/setting'
import './styles.css'

const DemoBanner = () => {
  // hooks
  const { isDemoUser, isDemoTenant } = useDemoUser()
  const { settings } = useContext(SettingsContext)
  const { appBarHidden } = settings

  // variables
  const shouldRender = useMemo(() => isDemoUser, [isDemoUser])

  const content = useMemo(() => {
    return isDemoTenant
      ? 'You are viewing a read-only demo. Mutating actions are disabled.'
      : 'You have readonly access. Mutating actions are disabled.'
  }, [isDemoTenant])

  if (!shouldRender) return null

  return (
    !appBarHidden && (
      <Box
        className="demo-banner-container"
        role="status"
        aria-label="Demo mode active"
      >
        <Box className="demo-banner-dot" />

        {isDemoTenant && (
          <>
            <Typography className="demo-banner-label">Demo Mode</Typography>
            <Typography className="demo-banner-separator">•</Typography>
          </>
        )}

        <Typography className="demo-banner-desc">{content}</Typography>
      </Box>
    )
  )
}

export default memo(DemoBanner)
